import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/projects/page.tsx");
